import { createReducer, on } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from '../actions';
import { setTransitionAnalyses } from './transition-analyses.actions';
export const transitionAnalyses = createReducer({}, on(setTransitionAnalyses, (state, action) => {
    return action.transitionAnalyses;
}), on(resetAllCustomPdfReportItems, () => {
    return {};
}));
